import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": Object.assign(Object.assign({}, theme.typography.body2), { fontWeight: theme.typography.fontWeightBold, "&.MuiBadge-colorInfo": {
            backgroundColor: theme.palette.grey[200],
        } }),
}));

export { PeekBadge, PeekBadge as default };
